import hdrm from '../../hdrm';
import site from '../../site';
import globals from '../../globals';
import actionTypes from '../constants/action-types';
import getFocusedElement from '../selectors/focused-element';
import setFocusedElement from '../actions/set-focused-element';
import { UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';

const handleDeleteElementAction = (store, action) => {
  const { elementId, options } = action.payload;
  const { strategy } = options;
  const state = store.getState();
  const focusedElementId = getFocusedElement(state);

  if (focusedElementId && elementId === focusedElementId) {
    store.dispatch(setFocusedElement(null));
  }

  return hdrm.operations.deleteElement(elementId, strategy);
};

const deleteElement = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.BULK_VIEW_ACTIONS: {
      const actions = action.payload.actions.filter(
        (targetAction) =>
          targetAction.type === actionTypes.CUT_ELEMENT ||
          targetAction.type === actionTypes.DELETE_ELEMENT
      );

      if (!actions.length) {
        next(action);
        return;
      }

      const state = store.getState();
      const pageId = site.selectors.getActivePageId(state);

      const newHTML = actions.reduce((_, subAction) => {
        const { globalsToUpdate } = subAction.payload;
        globals.helpers.saveGlobals(globalsToUpdate);
        return handleDeleteElementAction(store, subAction);
      }, null);

      store.dispatch(site.actions.setPageHTML(pageId, newHTML));

      next(action);
      break;
    }
    case actionTypes.CUT_ELEMENT:
    case actionTypes.DELETE_ELEMENT: {
      const { globalsToUpdate, options } = action.payload;
      const { strategy } = options;

      const newHTML = handleDeleteElementAction(store, action);

      if (strategy !== UPDATE_LIVE_ONLY) {
        const state = store.getState();
        const pageId = site.selectors.getActivePageId(state);

        globals.helpers.saveGlobals(globalsToUpdate);
        store.dispatch(site.actions.setPageHTML(pageId, newHTML));
      }

      next(action);
      break;
    }
    default:
      next(action);
  }
};

export default deleteElement;
